module.exports = __webpack_public_path__ + "img/bg.a6333996.jpg";